<template>
	<div class="card">

		<div class="card-header">
			<img class="card-img-top" :src="item.img_path"    alt="Card image cap">
		</div>
		<div class="card-body">
			<h5 class="card-title">{{ item.title}}</h5>
			<div class="cont">{{item.spec}}
			</div>
		</div>
			<div class="flex">		
			<b-btn 
					v-if="item.ost"
					variant="outline-primary" 
					@click="ost()"
					>
					Наличие
				</b-btn>
			<app-modal :item = item></app-modal>
			</div>
		

	</div>

</template>

<script>
 import AppModal from "../components/AppModal.vue"

export default {
	props:['item'],
	methods:{
		ost(){
			this.$store.commit('all/setBrand', {'brand':this.item.title,'post':this.item.ost,'card':false})
		}
	},
	components:{ AppModal	}

}
</script>
<style scoped>
	.card{
		width: 100%;
		min-width: 225px;
		max-width: 250px;
	}
	.card-header{
		height: 150px;
		background-color: #fff;
		overflow: hidden;
		display: flex;
    	align-items: center;
    	padding: 0;

	}
	.card-header img{
		max-height: 100%;
	}
	.cont{
		overflow: hidden;
	    text-overflow: ellipsis;
	    display: -webkit-box;
	    -webkit-line-clamp: 6;
	    -webkit-box-orient: vertical;
		}
	.flex{
		align-items: center;
    	display: flex;
    	justify-content: space-around;
	}

</style>
